import EntryTags from "./js/EntryTags";
export default EntryTags;